export const getBirthProcessTypeOptions = (t) => [
    { value: 'normal_simple', label: t('admin.event.birth_type_normal_simple') },
    { value: 'normal_doble', label: t('admin.event.birth_type_normal_doble') },
    { value: 'distocico_simple', label: t('admin.event.birth_type_dystocia_simple') },
    { value: 'distocico_doble', label: t('admin.event.birth_type_dystocia_doble') }
]